// Generate random gradient backgrounds for project cards
const colorPalettes = [
  { from: '#667eea', to: '#764ba2' },
  { from: '#f093fb', to: '#f5576c' },
  { from: '#4facfe', to: '#00f2fe' },
  { from: '#43e97b', to: '#38f9d7' },
  { from: '#fa709a', to: '#fee140' },
  { from: '#30cfd0', to: '#330867' },
  { from: '#a8edea', to: '#fed6e3' },
  { from: '#ff9a56', to: '#ff6a88' },
  { from: '#2e2e78', to: '#662d91' },
  { from: '#0ba360', to: '#3cba92' },
];

const techIcons = [
  '🤖', '⚛️', '🔷', '🐍', '🚀', '📊', '🎨', '💻', '🔐', '🌐',
  '📱', '⚙️', '🗄️', '💾', '🔗', '📡', '🎯', '🛠️', '📦', '🔄'
];

export const getRandomProjectImage = (index: number): string => {
  const palette = colorPalettes[index % colorPalettes.length];
  const icon = techIcons[Math.floor(Math.random() * techIcons.length)];
  
  return `linear-gradient(135deg, ${palette.from} 0%, ${palette.to} 100%)`;
};

export const getProjectIcon = (index: number): string => {
  return techIcons[index % techIcons.length];
};

export const generateGradientSvg = (from: string, to: string, icon: string): string => {
  return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 300'%3E%3Cdefs%3E%3ClinearGradient id='grad' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:${encodeURIComponent(from)};stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:${encodeURIComponent(to)};stop-opacity:1' /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='400' height='300' fill='url(%23grad)'/%3E%3Ctext x='50%25' y='50%25' font-size='100' text-anchor='middle' dominant-baseline='middle' fill='white' opacity='0.8' font-family='system-ui'%3E${icon}%3C/text%3E%3C/svg%3E`;
};
